import { styled } from "styled-components";
import theme from "styled-theming";

import Icon from "components/Icon";
import Link from "components/Link";
import { styleBodyM, styleHeadingS } from "style/components/Typography";

const textColor = theme("theme", {
    lightgray: "--text-on-neutral-primary",
    blue: "--text-on-blue-primary",
    cyan: "--text-on-cyan-primary",
});

export const Container = styled.div`
    display: flex;
    flex-flow: column wrap;
`;
export const HeadingArrow = styled(Icon)`
    color: var(${textColor});
    margin-left: 0.875rem;
    margin-right: 0.875rem;
    transition:
        margin-left 0.2s ease-in-out,
        margin-right 0.2s ease-in-out,
        color 0.2s ease-in-out;
    vertical-align: middle;
`;

export const Heading = styled(Link)`
    ${styleHeadingS}
    border: none;

    &:hover {
        ${HeadingArrow} {
            margin-left: 1.75rem;
            margin-right: 0;
        }
    }
`;

export const Address = styled.div`
    ${styleBodyM};
`;
